import { render } from "./verifyStatusCard.vue?vue&type=template&id=e873cd06"
import script from "./verifyStatusCard.vue?vue&type=script&lang=js"
export * from "./verifyStatusCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__